"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _TransfersComponent = _interopRequireDefault(require("./TransfersComponent"));
var _transferRequestActions = require("../../redux/actions/transferRequestActions");
var _transfersTableSelectors = require("../../redux/selectors/transfersTableSelectors");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _transfersByProductId = (0, _transfersTableSelectors.transfersByProductIdSelector)(state),
    receivedRequests = _transfersByProductId.receivedRequests,
    sentRequests = _transfersByProductId.sentRequests,
    sentTransfers = _transfersByProductId.sentTransfers,
    receivedTransfers = _transfersByProductId.receivedTransfers;
  var formSelector = (0, _reduxForm.formValueSelector)('transfers-filters-form');
  var selectedFilter = formSelector(state, 'transfersFilters');
  var products = state.apexCore.product.products;
  var usePagination = _config["default"].OrderHistoryData.usePagination;
  var addProduct = function addProduct(item) {
    return item.product = products.find(function (p) {
      return item.ProductId === p.ProductId;
    });
  };
  receivedRequests.forEach(addProduct);
  sentRequests.forEach(addProduct);
  sentTransfers.forEach(addProduct);
  receivedTransfers.forEach(addProduct);
  return {
    receivedRequests: receivedRequests,
    sentRequests: sentRequests,
    sentTransfers: sentTransfers,
    receivedTransfers: receivedTransfers,
    usePagination: usePagination,
    selectedFilter: selectedFilter ? selectedFilter : 'sentTransfers'
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    approveTransferRequest: function approveTransferRequest(requestCode) {
      return dispatch((0, _transferRequestActions.approveTransferRequest)(requestCode));
    },
    rejectTransferRequest: function rejectTransferRequest(requestCode) {
      return dispatch((0, _transferRequestActions.rejectTransferRequest)(requestCode));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TransfersComponent["default"]);